<div class="white_paper_wrap">
    <div class="paper_top_sections">
        <h1>Trinka与Grammarly、LanguageTool<br />在学术文件上的比较</h1>
    </div>

    <div class="need_whitePaper_section">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="need_content_text">
                        <h2>为什么需要此白皮书？</h2>
                        <p>一般英语有几种语法检查工具，但很少专门针对学术英语写作、术语、科学惯例以及与出版准备相关的问题。</p>

                        <p>深入阅读本白皮书将使您能够在评估和使用写作助手、语法检查工具和语言纠正工具时做出最明智的决定，以用于您的个人、专业、学术或技术写作。</p>

                        <p>本白皮书将为您提供准确的理解和数据支持，让您了解Trinka为什么最适合学术写作。这是因为它在准确性、覆盖率以及专门用于出版物准备就绪的功能之间取得了很好的平衡。</p>
                        <div class="download_whitePaper text-center">
                            <a id="downloadThisWhitePaper" href="assets/resources/Trinka-grammarly-Language-tool-CN.pdf" download="trinka-vs-grammarly-vs-language-tool">
                                <img src="assets/images/whitePaper_download.png" alt="">下载此白皮书</a>
                        </div>
                        <div class="key_takewaye_sections">
                            <h2>要奌</h2>
                            <div class="row">
                                <div class="col-lg-3 col-md-6">
                                    <div class="takeaways_cards">
                                        <div class="card_overlay"></div>
                                        <div class="cards_headers">
                                            <p>1</p>
                                        </div>
                                        <div class="need_cards_body">
                                            <p>全球作家、作者和专业学术作家的特定痛点。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-6">
                                    <div class="takeaways_cards">
                                        <div class="card_overlay"></div>
                                        <div class="cards_headers">
                                            <p>2</p>
                                        </div>
                                        <div class="need_cards_body">
                                            <p>当前可用的写作助手的可操作性和局限性。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-6">
                                    <div class="takeaways_cards">
                                        <div class="card_overlay"></div>
                                        <div class="cards_headers">
                                            <p>3</p>
                                        </div>
                                        <div class="need_cards_body">
                                            <p>Trinka、Grammarly以及LanguageTool的简要比较。</p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-3 col-md-6">
                                    <div class="takeaways_cards">
                                        <div class="card_overlay"></div>
                                        <div class="cards_headers">
                                            <p>4</p>
                                        </div>
                                        <div class="need_cards_body">
                                            <p>Trinka胜过所有其他写作助手。</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <p class="disclaimer-txt"><strong>免责声明:</strong> 一个订单只能使用一张优惠券、折扣、报价或促销。</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="sneak_peek_sections">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="sneak_heading">
                        <h2>了解一下本白皮书</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section class="whitePaper_slider testimonials">
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <div class="center">

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/WhitePaper/slide-1.jpg" alt="">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/WhitePaper/slide-2.jpg" alt="">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/WhitePaper/slide-3.jpg" alt="">
                        </div>

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/WhitePaper/slide-4.jpg" alt="">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/WhitePaper/slide-5.jpg" alt="">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/WhitePaper/slide-6.jpg" alt="">
                        </div>

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/WhitePaper/slide-7.jpg" alt="">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/WhitePaper/slide-8.jpg" alt="">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/WhitePaper/slide-9.jpg" alt="">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/WhitePaper/slide-10.jpg" alt="">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/WhitePaper/slide-11.jpg" alt="">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/WhitePaper/slide-1.jpg" alt="">
                        </div>

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/WhitePaper/slide-2.jpg" alt="">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/WhitePaper/slide-3.jpg" alt="">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/WhitePaper/slide-4.jpg" alt="">
                        </div>

                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/WhitePaper/slide-5.jpg" alt="">                            
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/WhitePaper/slide-6.jpg" alt="">
                        </div>
                        <div class="slider_section">
                            <div class="overlay_whitepaper"></div>
                            <img src="assets/images/WhitePaper/slide-7.jpg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- <div class="container">

            <div class="row">
                <div class="col-sm-12">
                    <div id="customers-testimonials" class="owl-carousel">
                        <div class="item">
                            <div class="shadow-effect">
                                <div class="overlay_whitepaper"></div>
                                <img src="assets/images/whitePaperSlide_02.png" alt="">
                            </div>
                        </div>

                        <div class="item">
                            <div class="shadow-effect">
                                <div class="overlay_whitepaper"></div>
                                <img src="assets/images/WhitePaperSlider_01.png" alt="">
                            </div>
                        </div>
                        
                        <div class="item">
                            <div class="shadow-effect">
                                <div class="overlay_whitepaper"></div>
                                <img src="assets/images/WhitePaperSlider_03.png" alt="">
                            </div>
                        </div>
                        
                        <div class="item">
                            <div class="shadow-effect">
                                <div class="overlay_whitepaper"></div>
                                <img src="assets/images/whitePaperSlide_02.png" alt="">
                            </div>
                        </div>

                        <div class="item">
                            <div class="shadow-effect">
                                <div class="overlay_whitepaper"></div>
                                <img src="assets/images/WhitePaperSlider_01.png" alt="">
                            </div>
                        </div>
                        
                        <div class="item">
                            <div class="shadow-effect">
                                <div class="overlay_whitepaper"></div>
                                <img src="assets/images/WhitePaperSlider_03.png" alt="">
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div> -->
    </section>

    <!-- <div class="whtiePaper_sections">
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <div class="WhitePaper_cards slicer_changes">
                        <div class="overlay_whitepaper"></div>
                        <img src="assets/images/WhitePaperSlider_01.png" alt="">
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="WhitePaper_cards">
                        <img src="assets/images/whitePaperSlide_02.png" alt="">
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="WhitePaper_cards slicer_changes">
                        <div class="overlay_whitepaper"></div>
                        <img src="assets/images/WhitePaperSlider_03.png" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div> -->

    <div class="bottomSilderButtons">
        <div class="download_whitePaper text-center">
            <a id="downloadThisWhitePaperFooter" href="assets/resources/Trinka-grammarly-Language-tool-CN.pdf" download="trinka-vs-grammarly-vs-language-tool">
                <img src="assets/images/whitePaper_download.png" alt="">下载此白皮书</a>
        </div>
    </div>
</div>